var render = function render(_c,_vm){return (_vm.props.duration && (_vm.props.watched !== null && _vm.props.watched !== undefined))?_c('div',{staticClass:"attachment-progress-component"},[_c('div',{staticClass:"progress-bar",style:({ width: `${Math.round((_vm.props.watched/Number(_vm.props.duration)) * 100)}%` })})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }